export default __webpack_public_path__ + "static/media/helo3.e9c4c4fd.png";